import { GetDepartment, SaveDepartment, DelDepartment, SetDepartmentAdmin } from '@/api/department'
export default {
  state: {

  },
  getters: {

  },
  actions: {
    GetDepartment ({ commit }, payload) {
      return new Promise(resolve => {
        GetDepartment(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveDepartment ({ commit }, payload) {
      return new Promise(resolve => {
        SaveDepartment(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DelDepartment ({ commit }, payload) {
      return new Promise(resolve => {
        DelDepartment(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SetDepartmentAdmin ({ commit }, payload) {
      return new Promise(resolve => {
        SetDepartmentAdmin(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  mutations: {

  }
}
